import twttr from 'twitter-text';

export const parseTwitterText = (tweet: string) => {
    return twttr.parseTweet(tweet);
};
